import React, { useCallback, useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LocationTargetsGrid } from '../location-targets-grid/index';
import { getStyles } from './get-styles';
import { BingMapsSearchBox } from '../bing-maps-search-box/index';
import { BingMapsWithZoomButton } from '../bing-maps-view/index';
import {
  LocationTarget,
} from '../util/index';

function LocationSpecificEditorUnstyled(props) {
  const {
    classes,
    mapRef,
    searchBoxHeader,
    searchBoxFooter,
    locationTargets,
    onLocationTargetsChange,
    searchChangeDebounceWait,
    placeholder,
    noResultsMessage,
    searchResultsFooter,
    searchResultsFooterOnClick,
  } = props;

  const i18n = useContext(I18nContext);

  const getIsRadiusTarget = useCallback(() => false, []);

  return (
    <div className={`bing-maps-location-specific-editor  ${classes.bingMapsLocationTargetsEditor}`}>
      <div className="bing-maps-location-target-and-map">
        <div className="bing-maps-location-targets-search-grid">
          <div className="search-box">
            {searchBoxHeader &&
              <div className="search-box-header">{searchBoxHeader}</div>}
            <BingMapsSearchBox
              getIsSearchResultRadiusTarget={getIsRadiusTarget}
              locationTargets={locationTargets}
              changeDebounceWait={searchChangeDebounceWait}
              onLocationTargetsChange={onLocationTargetsChange}
              isExcludeEnabled={false}
              placeholder={placeholder}
              noResultsMessage={noResultsMessage}
              searchResultsFooter={searchResultsFooter}
              searchResultsFooterOnClick={searchResultsFooterOnClick}
              ariaLabel={searchBoxHeader || i18n.getString(_TL_('Business location'))}
            />
            {searchBoxFooter &&
              <div className="search-box-footer">{searchBoxFooter}</div>}
          </div>
          <div
            className="bing-maps-location-targets-grid bing-maps-location-targets-grid-specific-only"
            aria-live="polite"
          >
            <LocationTargetsGrid
              isNegativeLocationTargetsGrid={false}
              locationTargets={locationTargets}
              onLocationTargetsChange={onLocationTargetsChange}
              onGetErrorMessage={_.noop}
              onLocationTargetGetErrorMessage={_.noop}
            />
          </div>
        </div>
        <BingMapsWithZoomButton
          mapRef={mapRef}
          locationTargets={locationTargets}
        />
      </div>
    </div>
  );
}

LocationSpecificEditorUnstyled.propTypes = {
  classes: PropTypes.shape({ bingMapsLocationTargetsEditor: PropTypes.string }).isRequired,
  searchBoxHeader: PropTypes.string,
  searchBoxFooter: PropTypes.string,
  locationTargets: PropTypes.arrayOf(PropTypes.instanceOf(LocationTarget)).isRequired,
  onLocationTargetsChange: PropTypes.func.isRequired,
  searchChangeDebounceWait: PropTypes.number,
  placeholder: PropTypes.string,
  noResultsMessage: PropTypes.string,
  searchResultsFooter: PropTypes.func,
  searchResultsFooterOnClick: PropTypes.func,
  /**
 * Ref that can be used to trigger actions in the map web control like zooming.
 */
  mapRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.shape({}) }),
  ]),
};

LocationSpecificEditorUnstyled.defaultProps = {
  searchChangeDebounceWait: 100,
  placeholder: '',
  searchBoxHeader: '',
  searchBoxFooter: '',
  noResultsMessage: '',
  searchResultsFooter: null,
  searchResultsFooterOnClick: _.noop,
  mapRef: null,
};

export const LocationSpecificEditor = withDefaultStyles(LocationSpecificEditorUnstyled, getStyles);
